import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B131E] text-gray-400 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2 text-white">
          <Compass className="w-5 h-5 text-amber-500" />
          <span className="font-serif text-xl font-semibold">Wanderlust</span>
        </div>
        <p className="mt-3 text-sm leading-relaxed max-w-xs">Escapades locales de 1 à 3 jours, cohérentes et au budget clair.</p>
        <p data-testid="footer-brand-line" className="mt-2 text-xs text-gray-500">Wanderlust — une application Amagui AI</p>
      </div>
      <div className="text-sm space-y-2">
        <p className="font-mono text-xs uppercase tracking-widest text-amber-500 mb-3">Légal</p>
        <Link to="/mentions-legales" data-testid="footer-mentions-link" className="block hover:text-white transition-colors">Mentions légales</Link>
        <Link to="/cgv" data-testid="footer-cgv-link" className="block hover:text-white transition-colors">CGV Premium</Link>
        <Link to="/confidentialite" data-testid="footer-privacy-link" className="block hover:text-white transition-colors">Politique de confidentialité</Link>
      </div>
      <div className="text-sm space-y-2">
        <p className="font-mono text-xs uppercase tracking-widest text-amber-500 mb-3">Contact</p>
        <a href="mailto:contact@wanderlust.fr" data-testid="footer-contact-link" className="block hover:text-white transition-colors">contact@wanderlust.fr</a>
        <Link to="/acces" data-testid="footer-recover-link" className="block hover:text-white transition-colors">Retrouver mon accès Premium</Link>
        <p>Paiement sécurisé par Stripe</p>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-gray-500">© {new Date().getFullYear()} <span data-testid="footer-brand" className="text-gray-300">Wanderlust by Amagui AI</span> — Estimations indicatives, prix à vérifier avant réservation.</div>
  </footer>
);
